module.exports = __webpack_public_path__ + "media/honey-icons/icon-reassurance-01baad91.svg";